import { createFileRoute } from "@tanstack/react-router";

import { BrandingSettingsPanel } from "../components/settings/BrandingSettings";

export const Route = createFileRoute("/settings/branding")({
  component: BrandingSettingsPanel,
});
